var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Checkbox, Flex, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { SketchPicker } from 'react-color';
import { BaseDialog, BaseDialogState } from './BaseDialog';
export class DiagramPropertyState {
    constructor() {
        this.color = "";
        this.textcolor = "white";
        this.onok = undefined;
        this.basedialogState = new BaseDialogState();
        this.showtextproperty = true;
        this.boldtext = false;
        this.italictext = false;
        this.underline = false;
        this.fontsize = 18;
        makeObservable(this);
        this.basedialogState.setOkLabel("Apply");
        this.basedialogState.setHeaderLabel("Property");
        this.basedialogState.onOk = () => {
            var _a;
            (_a = this.onok) === null || _a === void 0 ? void 0 : _a.call(this);
        };
    }
    setShowTextProperty(show) {
        this.showtextproperty = show;
    }
    setbold(show) {
        this.boldtext = show;
    }
    setItalic(show) {
        this.italictext = show;
    }
    setTextColor(color) {
        this.textcolor = color;
    }
    setColor(color) {
        this.color = color;
    }
    setFontSize(size) {
        this.fontsize = size;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyState.prototype, "color", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyState.prototype, "textcolor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyState.prototype, "showtextproperty", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyState.prototype, "boldtext", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyState.prototype, "italictext", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyState.prototype, "underline", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyState.prototype, "fontsize", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyState.prototype, "setShowTextProperty", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyState.prototype, "setbold", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyState.prototype, "setItalic", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DiagramPropertyState.prototype, "setTextColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DiagramPropertyState.prototype, "setColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DiagramPropertyState.prototype, "setFontSize", null);
let DiagramProperty = class DiagramProperty extends React.Component {
    constructor(prop) {
        super(prop);
    }
    dialog() {
        return React.createElement(Box, null,
            React.createElement(Flex, null,
                React.createElement(Flex, { mt: '10px' },
                    React.createElement(Text, { mr: '10px', fontWeight: 'bold' }, "Color: "),
                    React.createElement(Box, null,
                        React.createElement(Box, { style: { width: 20, height: 20, borderRadius: 10, backgroundColor: this.props.state.color } }),
                        React.createElement(Box, { mt: '10px' },
                            React.createElement(SketchPicker, { color: this.props.state.color, onChange: ({ hex }) => this.props.state.setColor(hex) })))),
                this.props.state.showtextproperty && React.createElement(Flex, { ml: '30px', mt: '10px' },
                    React.createElement(Text, { mr: '10px', fontWeight: 'bold' }, "Text Color: "),
                    React.createElement(Box, null,
                        React.createElement(Box, { style: { width: 20, height: 20, borderRadius: 10, backgroundColor: this.props.state.textcolor } }),
                        React.createElement(Box, { mt: '10px' },
                            React.createElement(SketchPicker, { color: this.props.state.textcolor, onChange: ({ hex }) => this.props.state.setTextColor(hex) }))))),
            this.props.state.showtextproperty && React.createElement(Flex, { ml: '30px', mt: '30px' },
                React.createElement(Text, { mr: '10px', fontWeight: 'bold' }, "Text Properties: "),
                React.createElement(Checkbox, { onChange: (e) => this.props.state.setbold(e.currentTarget.checked), defaultChecked: this.props.state.boldtext }, "Bold"),
                React.createElement(Checkbox, { onChange: (e) => this.props.state.setItalic(e.currentTarget.checked), ml: '10px', defaultChecked: this.props.state.italictext }, "Italic")));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
DiagramProperty = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DiagramProperty);
export { DiagramProperty };
